const photosTemplate = require('20220101/templates/widgets/patchwork/photos.hbs');
const indexTemplate = require('20220101/templates/widgets/patchwork/index.hbs');
import widgetMixin from "./widget-mixin.js";

class PatchworkWidget extends widgetMixin(HTMLElement) {
  constructor() {
    super();

    this.photos = [];
    this.page = 1;
    this.per = 10;
    this.fetchMorePhotos = false;
  }

  processPhotos(data) {
    this.appendPhotos(this.groupedPhotos(data.photos));
  }

  groupedPhotos(photos) {
    const results = [];
    for (let i = 0; i < photos.length; i += 5) {
      results.push(photos.slice(i , + (i + 4) + 1 || undefined));
    }

    return results;
  }

  render() {
    this.renderIndex();
    this.appendPhotos(this.groupedPhotos(this.photos));
  }

  renderIndex() {
    const renderedIndex = indexTemplate({photos: this.photos, preferences: this.preferences, uuid: this.uuid});
    this.shadow.innerHTML = renderedIndex;
    this.appendCustomCSS();
  }

  appendPhotos(photos) {
    const renderedPhotos = photosTemplate({photos, preferences: this.preferences});
    this.shadow.querySelector('.l2h-photos').insertAdjacentHTML('beforeend', renderedPhotos);
    this.renderHeader();
  }
}


customElements.define('l2h-patchwork-widget', PatchworkWidget);
